// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Satoshi-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Satoshi-Variable.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Satoshi-Variable.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Satoshi-VariableItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Satoshi-VariableItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Satoshi-VariableItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Satoshi-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Satoshi-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Satoshi-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Satoshi-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Satoshi-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Satoshi-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Satoshi-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Satoshi-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Satoshi-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Satoshi-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Satoshi-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/Satoshi-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Satoshi-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Satoshi-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Satoshi-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Satoshi-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Satoshi-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Satoshi-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Satoshi-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Satoshi-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Satoshi-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Satoshi-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Satoshi-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Satoshi-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Satoshi-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Satoshi-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Satoshi-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Satoshi-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/Satoshi-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/Satoshi-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 *
 * Font Family: Satoshi
 * Designed by: Deni Anggara
 * URL: https://www.fontshare.com/fonts/satoshi
 * © 2022 Indian Type Foundry
 *
 * Font Styles:
 * Satoshi Variable(Variable font)
 * Satoshi Variable Italic(Variable font)
 * Satoshi Light
 * Satoshi Light Italic
 * Satoshi Regular
 * Satoshi Italic
 * Satoshi Medium
 * Satoshi Medium Italic
 * Satoshi Bold
 * Satoshi Bold Italic
 * Satoshi Black
 * Satoshi Black Italic
 *
*/


/**
* This is a variable font
* You can controll variable axes as shown below:
* font-variation-settings: 'wght' 900.0;
*
* available axes:

* 'wght' (range from 300.0 to 900.0)

*/

@font-face {
  font-family: 'Satoshi-Variable';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
       font-weight: 300 900;
       font-display: swap;
       font-style: normal;
}


/**
* This is a variable font
* You can controll variable axes as shown below:
* font-variation-settings: 'wght' 900.0;
*
* available axes:

* 'wght' (range from 300.0 to 900.0)

*/

@font-face {
  font-family: 'Satoshi-VariableItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
       font-weight: 300 900;
       font-display: swap;
       font-style: italic;
}


@font-face {
  font-family: 'Satoshi-Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
       font-weight: 300;
       font-display: swap;
       font-style: normal;
}


@font-face {
  font-family: 'Satoshi-LightItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
       font-weight: 300;
       font-display: swap;
       font-style: italic;
}


@font-face {
  font-family: 'Satoshi-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
       font-weight: 400;
       font-display: swap;
       font-style: normal;
}


@font-face {
  font-family: 'Satoshi-Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
       font-weight: 400;
       font-display: swap;
       font-style: italic;
}


@font-face {
  font-family: 'Satoshi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype');
       font-weight: 500;
       font-display: swap;
       font-style: normal;
}


@font-face {
  font-family: 'Satoshi-MediumItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
       font-weight: 500;
       font-display: swap;
       font-style: italic;
}


@font-face {
  font-family: 'Satoshi-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('truetype');
       font-weight: 700;
       font-display: swap;
       font-style: normal;
}


@font-face {
  font-family: 'Satoshi-BoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('truetype');
       font-weight: 700;
       font-display: swap;
       font-style: italic;
}


@font-face {
  font-family: 'Satoshi-Black';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('truetype');
       font-weight: 900;
       font-display: swap;
       font-style: normal;
}


@font-face {
  font-family: 'Satoshi-BlackItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format('truetype');
       font-weight: 900;
       font-display: swap;
       font-style: italic;
}

`, "",{"version":3,"sources":["webpack://./src/assets/web/css/satoshi.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;CAsBC;;;AAGD;;;;;;;;;CASC;;AAED;EACE,+BAA+B;EAC/B;;iEAE4D;OACvD,oBAAoB;OACpB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;;;;;;;;;CASC;;AAED;EACE,qCAAqC;EACrC;;iEAEkE;OAC7D,oBAAoB;OACpB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,4BAA4B;EAC5B;;iEAEyD;OACpD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,kCAAkC;EAClC;;kEAE+D;OAC1D,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,8BAA8B;EAC9B;;kEAE2D;OACtD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,6BAA6B;EAC7B;;kEAE0D;OACrD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,sBAAsB;EACtB;;kEAE0D;OACrD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,mCAAmC;EACnC;;kEAEgE;OAC3D,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,2BAA2B;EAC3B;;kEAEwD;OACnD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,iCAAiC;EACjC;;kEAE8D;OACzD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,4BAA4B;EAC5B;;kEAEyD;OACpD,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB;;;AAGA;EACE,kCAAkC;EAClC;;kEAE+D;OAC1D,gBAAgB;OAChB,kBAAkB;OAClB,kBAAkB;AACzB","sourcesContent":["/**\n * @license\n *\n * Font Family: Satoshi\n * Designed by: Deni Anggara\n * URL: https://www.fontshare.com/fonts/satoshi\n * © 2022 Indian Type Foundry\n *\n * Font Styles:\n * Satoshi Variable(Variable font)\n * Satoshi Variable Italic(Variable font)\n * Satoshi Light\n * Satoshi Light Italic\n * Satoshi Regular\n * Satoshi Italic\n * Satoshi Medium\n * Satoshi Medium Italic\n * Satoshi Bold\n * Satoshi Bold Italic\n * Satoshi Black\n * Satoshi Black Italic\n *\n*/\n\n\n/**\n* This is a variable font\n* You can controll variable axes as shown below:\n* font-variation-settings: 'wght' 900.0;\n*\n* available axes:\n\n* 'wght' (range from 300.0 to 900.0)\n\n*/\n\n@font-face {\n  font-family: 'Satoshi-Variable';\n  src: url('../fonts/Satoshi-Variable.woff2') format('woff2'),\n       url('../fonts/Satoshi-Variable.woff') format('woff'),\n       url('../fonts/Satoshi-Variable.ttf') format('truetype');\n       font-weight: 300 900;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n/**\n* This is a variable font\n* You can controll variable axes as shown below:\n* font-variation-settings: 'wght' 900.0;\n*\n* available axes:\n\n* 'wght' (range from 300.0 to 900.0)\n\n*/\n\n@font-face {\n  font-family: 'Satoshi-VariableItalic';\n  src: url('../fonts/Satoshi-VariableItalic.woff2') format('woff2'),\n       url('../fonts/Satoshi-VariableItalic.woff') format('woff'),\n       url('../fonts/Satoshi-VariableItalic.ttf') format('truetype');\n       font-weight: 300 900;\n       font-display: swap;\n       font-style: italic;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-Light';\n  src: url('../fonts/Satoshi-Light.woff2') format('woff2'),\n       url('../fonts/Satoshi-Light.woff') format('woff'),\n       url('../fonts/Satoshi-Light.ttf') format('truetype');\n       font-weight: 300;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-LightItalic';\n  src: url('../fonts/Satoshi-LightItalic.woff2') format('woff2'),\n       url('../fonts/Satoshi-LightItalic.woff') format('woff'),\n       url('../fonts/Satoshi-LightItalic.ttf') format('truetype');\n       font-weight: 300;\n       font-display: swap;\n       font-style: italic;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-Regular';\n  src: url('../fonts/Satoshi-Regular.woff2') format('woff2'),\n       url('../fonts/Satoshi-Regular.woff') format('woff'),\n       url('../fonts/Satoshi-Regular.ttf') format('truetype');\n       font-weight: 400;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-Italic';\n  src: url('../fonts/Satoshi-Italic.woff2') format('woff2'),\n       url('../fonts/Satoshi-Italic.woff') format('woff'),\n       url('../fonts/Satoshi-Italic.ttf') format('truetype');\n       font-weight: 400;\n       font-display: swap;\n       font-style: italic;\n}\n\n\n@font-face {\n  font-family: 'Satoshi';\n  src: url('../fonts/Satoshi-Medium.woff2') format('woff2'),\n       url('../fonts/Satoshi-Medium.woff') format('woff'),\n       url('../fonts/Satoshi-Medium.ttf') format('truetype');\n       font-weight: 500;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-MediumItalic';\n  src: url('../fonts/Satoshi-MediumItalic.woff2') format('woff2'),\n       url('../fonts/Satoshi-MediumItalic.woff') format('woff'),\n       url('../fonts/Satoshi-MediumItalic.ttf') format('truetype');\n       font-weight: 500;\n       font-display: swap;\n       font-style: italic;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-Bold';\n  src: url('../fonts/Satoshi-Bold.woff2') format('woff2'),\n       url('../fonts/Satoshi-Bold.woff') format('woff'),\n       url('../fonts/Satoshi-Bold.ttf') format('truetype');\n       font-weight: 700;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-BoldItalic';\n  src: url('../fonts/Satoshi-BoldItalic.woff2') format('woff2'),\n       url('../fonts/Satoshi-BoldItalic.woff') format('woff'),\n       url('../fonts/Satoshi-BoldItalic.ttf') format('truetype');\n       font-weight: 700;\n       font-display: swap;\n       font-style: italic;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-Black';\n  src: url('../fonts/Satoshi-Black.woff2') format('woff2'),\n       url('../fonts/Satoshi-Black.woff') format('woff'),\n       url('../fonts/Satoshi-Black.ttf') format('truetype');\n       font-weight: 900;\n       font-display: swap;\n       font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'Satoshi-BlackItalic';\n  src: url('../fonts/Satoshi-BlackItalic.woff2') format('woff2'),\n       url('../fonts/Satoshi-BlackItalic.woff') format('woff'),\n       url('../fonts/Satoshi-BlackItalic.ttf') format('truetype');\n       font-weight: 900;\n       font-display: swap;\n       font-style: italic;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
